import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import { Paper, Button } from "@material-ui/core";
import { AdminSettingTableHeading } from "../../Utils/appConstants";
import { getAdminSettingsList, updateAdminSettingsApi } from "../../service/api";
import { Box } from "@material-ui/core";
import Loaderpage from "../../pages/LoaderPage";
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles({
  table: {
    border: "1px solid #e1e1e1",
  },
  tableRow: {
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeaderRow: {
    borderTop: "1px solid #e1e1e1",
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeadFont: {
    fontWeight: 600,
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
  },
  actionButton: {
    paddingTop: '16px',
    alignSelf: 'center'
  },
  eventSystemAdminContianer: {
    display: 'flex',
    flexDirection: 'column'
  }
});


const AdminSettingComponent = (props) => {
  const classes = useStyles();
  const [adminSettingListData, setAdminSettingListData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [updateError, setUpdateError] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  let modifiedAdminDataList = [];
  useEffect(async () => {
    getAdminSettingList();
  }, []);

  const resetAdminSetting = () => {
    getAdminSettingList();
  }

  const getAdminSettingList = async () => {
    setLoader(true);
    const data = 'SYSTEM';
    const adminSettingList = await getAdminSettingsList(data);
    setAdminSettingListData(adminSettingList?.data?.adminSettings);
    setLoader(false);
  }
    
  const updateAdminSetting = async () => {
    const body = modifiedAdminDataList;
    setLoader(true);
    const updatedAdminSettingValue = await updateAdminSettingsApi(body);
    if (updatedAdminSettingValue?.data && updatedAdminSettingValue?.data[0]?.success === 'TRUE') {
      setUpdateSuccess(true)
      setLoader(false);
      setUpdateError(false);
      getAdminSettingList();
    } else {
      setUpdateSuccess(false)
      setLoader(false);
      setUpdateError(true);
    }
  }

  const setAdminSettingValue = (e, element, prevValue) => {
    adminSettingListData?.map((item) => {
        if (item?.settingId === element?.settingId) {
            item.settingValue = e.target.value;
            if (prevValue !== e.target.value){
              item.prevSettingValue = prevValue;
            }
            if (modifiedAdminDataList.length > 0) {
              modifiedAdminDataList.map((itemData, indexData) => {
                    if (itemData.settingId === item.settingId) {
                      modifiedAdminDataList.splice(indexData, 1);
                    }
                    return modifiedAdminDataList;
                })
                return modifiedAdminDataList.push(item);
            } else {
              return modifiedAdminDataList.push(item);
            }
        }
        return modifiedAdminDataList;
    })
}

  return (
    <div className={classes.eventSystemAdminContianer}>
      <div>
      {!loader && <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead className={classes.tableHeaderRow}>
              <TableRow className={classes.tableHeadFont}>
                {AdminSettingTableHeading.map((item) => {
                  return (
                    <TableCell>
                      {item.label}
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {adminSettingListData && adminSettingListData
                ?.map((row, index) => (
                  <TableRow key={index} className={classes.tableRow}>
                    <TableCell>
                      <span className="textStyle">
                        {row?.settingName}
                      </span>
                    </TableCell>
                    <TableCell>
                      <TextField
                        className="adminTextContent"
                        label={props.textFieldPlaceHolderText}
                        defaultValue={row?.settingValue}
                        onChange={(e) => {
                          setAdminSettingValue(e, row, row?.prevSettingValue || row?.settingValue);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>}
      </div>
      <div className={classes.actionButton}>
        {updateError && !updateSuccess && <><div style={{ color: 'red' }}>Please adjust the Changes.</div> <br /></>}
        {updateSuccess && !updateError && <><div style={{ color: '#00C6B7' }}>Successfully Updated the changes.</div> <br /></>}
        <Box display={'flex'}
          sx={{
            "& .MuiButton-root": {
              m: 5
            }
          }}>
          <div style={{ paddingRight: '16px' }}>
            <Button
              className={`passButton ${classes.buttonHandle}`}
              color="primary"
              onClick={() => resetAdminSetting()}
            >
              Cancel
            </Button>
          </div>
          <div>
            <Button
              className={`purchaseButton ${classes.buttonHandle}`}
              color="primary"
              onClick={() => updateAdminSetting()}
            >
              Submit
            </Button>
          </div>
        </Box>

      </div>
      <div>
        {loader ? (
          <Box
            height={"350px"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <div>
              <Loaderpage />
              <span className="loaderText">Loading...</span>
            </div>
          </Box>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default AdminSettingComponent;